import { z } from 'zod'
import { investmentDefaultTabSchema } from './investment-default-tab.schema'

export const brokerAccountResponseSchema = z.object({
  id: z.string().guid(),
  tbankAccountId: z.string(),
  connectionId: z.string().guid(),
  name: z.string(),
  type: z.string(),
  status: z.string(),
  accessLevel: z.string(),
  hasFullToken: z.boolean(), // true when a persistent full-access token is stored for this account
  openedDate: z.coerce.date().nullable(),
  closedDate: z.coerce.date().nullable(),
  lastSyncedAt: z.coerce.date().nullable(),
  // accounts-integration (Phase B): set once the broker account is linked to a regular Account
  accountId: z.string().guid().nullable(),
  lastPortfolioSyncedAt: z.coerce.date().nullable(),
  // per-account bot visibility toggles (opt-in; hidden by default). a bot's tab/UI shows only
  // when its feature flag is enabled AND the matching toggle here is on.
  tradingBotVisible: z.boolean(),
  dayTradeBotVisible: z.boolean(),
  // the sub-nav tab this account opens on when its card is clicked or its bare URL is hit.
  // defaults to portfolio; navigation falls back to portfolio when it is no longer available.
  defaultTab: investmentDefaultTabSchema,
  // global drag-and-drop position across ALL of the user's broker accounts (not per-connection).
  // the Investments grid sorts the flattened, multi-connection list by this value.
  order: z.number().int(),
})

export type BrokerAccountResponseDto = z.infer<typeof brokerAccountResponseSchema>
